import React from 'react';
import '../svg.css';


const Studio_Art = props => {
    const { fill } = props;
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >
            <g id="messages_studioArt" data-name="messages/studioArt"><g id="Logo"><rect id="frame" className="studio_art-1" width="36" height="36" rx="10" /></g><polygon id="bound" className="studio_art-2" points="6 6 30 6 30 30 6 30 6 6" /><circle id="Oval-32" className="studio_art-3" cx="21" cy="23" r="5" /><circle id="Oval-32-Copy" className="studio_art-3" cx="15" cy="23" r="5" /><circle id="Oval-32-Copy-2" className="studio_art-3" cx="13" cy="17" r="5" /><circle id="Oval-32-Copy-3" className="studio_art-3" cx="23" cy="17" r="5" /><circle id="Oval-32-Copy-4" className="studio_art-3" cx="18" cy="13" r="5" /></g></svg>)
};

export default Studio_Art;
